// extracted by mini-css-extract-plugin
module.exports = {"editValuePopover":"editValuePopover___1t_ZE","title":"title___3JGil","footer":"footer___216uV"};